import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import {SocketCdnControl, socketEvents} from '../../services/sockets'
import {StreamProject} from "../../interfaces";
import { NbDialogService,NbGlobalPosition, NbToastrService } from '@nebular/theme';
@Component({
  selector: 'cdn-control',
  templateUrl: './cdn-control.component.html',
  styleUrls: ['./cdn-control.component.scss']
})
export class CdnControlComponent implements OnInit, OnDestroy {

   
  @Input() stream: StreamProject
 
  constructor(
    private socket: SocketCdnControl,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
  ) { 
    // this.socket.removeAllListeners()
    // this.socket.disconnect()
  }
 
  chet:boolean = false
  stat:any = false

  ngOnInit(): void { 
    //console.log(this.page)

    this.socket.on(socketEvents.cdnOnStat, this.statChanged.bind(this))
     this.socket.connect()

  }

	gerlyanda(data){
		 //let ar = data ? data.cdns : this.stat.cdns;
		//for(let i = 0; i < this.stat.cdns.langth; i++){
		let i = 0;
		for (let cdn of data?.cdns || this.stat.cdns){
			i++;
		
			//console.log('gerlyanda')
			let ch = false
			if (i % 2 == 0) {
  			 	ch = true
 			 } 

			if(this.chet ){

				if(ch){
				cdn.netStatus = 1

				}else {

				cdn.netStatus = 2
				}

				
			} else {
				if(!ch){
				cdn.netStatus = 1

				}else {

				cdn.netStatus = 2
				}
			}

		}
		
		this.chet = !this.chet 
	}

  setActivmentStatus(event, id){
     this.socket.emit('setActivmentStatus',{
      id,
      active: event.target.checked
    })
  }


	setInterface(event, id){
		 this.socket.emit('setInterface',{
		      id,
		      state: event.target.value
		    })



	}

	setTier(event, id){
		this.socket.emit('setTier', {
			id,
			tier: parseInt(event.target.value, 10) || 0
		})
	}

	setMode(mode: string){
		this.socket.emit('setDistributionMode', { mode })
	}

	setMaxWatchers(event, id){
		this.socket.emit('setMaxWatchers', {
			id,
			maxWatchers: parseInt(event.target.value, 10) || 0
		})
	}

  statChanged(data){
	 
    this.stat = data
 
   }

   openRefreshModal(content){
    this.dialogService.open(content,{hasScroll: true} )
   }

   refreshWatchers(ref){
 	ref.close()

		this.socket.emit('refreshWatchers',{})

		setTimeout(()=>{
		 this.toastrService.show('',`Watchers reloaded`,{
		      status: 'success',
			icon:'',
			position: <NbGlobalPosition>'bottom-end'
		    })

		},1000)
   }

  ngOnDestroy(){
    this.socket.disconnect()
    this.socket.removeAllListeners(socketEvents.cdnOnStat)

  }
}
